import React from "react";
import welcomeImage from "./assets/About_Image.webp";
import {
  aboutUsEventTimeLine,
  hippaPoints,
  choosePdvIcons,
  values,
} from "../landingpage/data/pdvLandingPageData";
import bg_down_arrow from "../landingpage/assets/pdvimages/bg_down_arrow.svg";
import "./styles/about.css";
import SectionHeader from "../landingpage/SectionHeader";
import misson_icon from "./assets/mission_icon.svg";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@mui/lab";
import { Card, CardContent, Typography } from "@mui/material";
import { strings } from "../utils/strings";
import HeaderComponent from "../landingpage/header/HeaderComponent";
import FooterComponent from "../landingpage/footer/FooterComponent";
import frame_17 from "../landingpage/assets/pdvimages/Frame-17.webp";
import frame_3182 from "../landingpage/assets/pdvimages/Frame-3182.webp";
import wheelchair_person from "../landingpage/assets/pdvimages/Group-3370.webp";
import { Helmet } from "react-helmet-async";
import StickyButton from "../../components/generic/stickybutton/StickyButton";

const AboutComponent = () => {
  return (
    <>
      <Helmet>
        <title>Discover PDV | Comprehensive Volunteer Management Solution</title>
        <meta name="description" content="Patient Data Vault a volunteer management solution designed for hospices. Learn more about our mission, values, and technology-driven approach." />
        <meta property="og:title" content="Discover PDV | Comprehensive Volunteer Management Solution" />
      </Helmet>
            <StickyButton />
    <section className="pdv-aboutus-page">
      <HeaderComponent />
      
      {/* ---Fold 1--- */}
      <section className="">
        <div className="container">
          <div className="row pt-2">
            <div className="welcome-screen-home-layout col-md-6 px-5 d-flex justify-content-center align-items-center">
              <div>
                <h1 className="aboutus-heading">{strings.ABOUT_US}</h1>
                <div className="my-1">{strings.ABOUT_US_DESCRIPTION}</div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <img
                src={welcomeImage}
                alt=" Hospice volunteer providing compassionate care to the patient ."
                className="img-fluid"
                width="80%"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ---Fold 2--- */}
      <section
        id="pos"
        className="my-5 position-relative our-mission-container"
      >
        <div className="bg_down_arrow">
          <img src={bg_down_arrow} alt="" className="img-fluid" />
        </div>
        <div className="container position-relative">
          <div className="row d-flex align-items-center">
            <div className="image-holder-div col-md-6">
              <div className="d-flex justify-content-center">
                <img
                  className="image-1-margin-div old-patient-suffering-from-par-icon m-1"
                  alt="Hospice volunteer providing support to an elderly patient"
                  src={wheelchair_person}
                  width="35%"
                />

                <img
                  className="image-2-margin-div old-patient-suffering-from-par-icon mt-5"
                  alt=""
                  src={frame_17}
                  width="35%"
                  height="25%"
                />
              </div>
              <div className="d-flex justify-content-center">
                <img
                  className="image-3-margin-div old-patient-suffering-from-par-icon m-1 mr-5 pr-7"
                  alt="Hospice volunteer & patient in a home care setting"
                  src={frame_3182}
                  width="35%"
                />
              </div>
            </div>
            
            <div className="col-md-6 container-fluid">
              <div className="what-is-pdv-div align-self-center">
                <div className="what-is-pdv-wrapper ">
                  <div className="what-is-pdv mt-3 font-weight-bold">
                    Who we are
                  </div>
                </div>
                <div className="the-patient-data my-3">
                  Patient Data Vault (PDV) helps hospices easily manage their
                  volunteer programs. Our system makes it easy to, track
                  volunteer hours, schedule, and communicate with volunteers
                  while keeping information safe and meeting compliance.
                </div>
                <div className="the-patient-data my-3">
                  The functional growth of PDV has been driven by the Hospice
                  Volunteer Association (HVA) and feedback from hospice
                  volunteers and managers. Their experience and dedication have
                  helped shape PDV into a useful tool that supports those who
                  provide care for patients at the end of life. With PDV,
                  thousands of volunteers have been able to offer comfort and
                  support to patients and families when they need it most.
                </div>
                <div className="the-patient-data my-3">
                  We believe volunteers are a vital part of hospice care. Our
                  goal is to give hospices the right tools to make volunteer
                  management easier, so they can focus on what matters
                  most—caring for people.
                </div>
                {/* <div className="learn-more-wrapper">
                        <button className="custom-button">Learn More</button>
                      </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Fold 3 --!> */}
      <section className="container mt-3">
        <SectionHeader title="Why Choose PDV?" />
        <div className="container">
          <div className="row justify-content-center d-flex align-items-stretch position-relative z-1">
            {choosePdvIcons.map((item, i) => (
              <div className="col-12 col-sm-6 col-md-3 d-flex" key={i}>
                <div className="values-card p-3 text-center mx-auto d-flex flex-column">
                  <img
                   src={item.icon}
                    className="mx-auto d-block"
                    alt="icon"
                     />
                  <p className="mt-3 values-card-title">{item.title}</p>
                  <p className="values-card-desc">{item.decscription}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fold 4 */}
      <section className="container">
        <Timeline position="alternate">
          {aboutUsEventTimeLine.map((item) => (
            <TimelineItem key={item.id}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {item.year}
                <Card style={{ backgroundColor: `${item.colorId}` }}>
                  <CardContent>
                    <Typography variant="h6" className="timeline-title">
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      className="timeline-description"
                    >
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </section>


      {/* <!-- Fold  --!> */}
      <div className=" our-mission-container mt-5">
        <section className="container">
          <div>
            <div className="mission-icon">
              <div className="bg_down_arrow_about">
                <img src={bg_down_arrow} alt="" className="img-fluid" />
              </div>
              <img src={misson_icon} alt="" />
            </div>
            <SectionHeader title="Our Mission" />
            <div className="text-center my-3">{strings.ABOUT_OUR_MISSION}</div>
          </div>
        </section>
        <section className="container mt-5">
          <SectionHeader title="Our Values" />
          <div className="container">
            <div className="row justify-content-center d-flex align-items-stretch position-relative z-1">
              {values.map((item, i) => (
                <div className="col-12 col-sm-6 col-md-3 d-flex" key={i}>
                  <div className="values-card p-3 text-center mx-auto d-flex flex-column">
                    <img
                      src={item.icon}
                      className="mx-auto d-block"
                      alt="icon"
                    />
                    <p className="mt-3 values-card-title">{item.title}</p>
                    <p className="values-card-desc">{item.decscription}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

            {/* Fold 6*/}
            <div className="m-3">
        <section className="container mt-5 compliant-container mb-5">
          <h2 className="compliant-container-title">
            {strings.ABOUT_HIPPA}
          </h2>
          <div className="compliant-container-desc mt-1">
            {hippaPoints.map((item) => (
              <p key={item.id}>{item.description}</p>
            ))}
          </div>
        </section>
      </div>

      <FooterComponent />
    </section>
    </>
  );
};

export default AboutComponent;
